import { ExternalLink } from 'lucide-react';

function ArticleRenderer({ blocks }) {
  const renderContent = (block, index) => {
    switch (block.type) {
      case 'heading':
        const HeadingTag = `h${block.level}`;
        return <HeadingTag key={index}>{block.content}</HeadingTag>;
      case 'paragraph':
        return block.emphasis === 'strong'
          ? <p key={index}><strong>{block.content}</strong></p>
          : <p key={index}>{block.content}</p>;
      case 'list':
        const ListTag = block.ordered ? 'ol' : 'ul';
        return (
          <ListTag key={index}>
            {block.items.map((item, idx) => (
              <li key={idx}>
                {typeof item === 'object' && item !== null && item.url ? (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'underline', display: 'inline-flex', alignItems: 'center', gap: '0.25em' }}
                  >
                    {item.content}
                    <ExternalLink size={16} style={{ marginLeft: '0.25em' }} />
                  </a>
                ) : (
                  item
                )}
              </li>
            ))}
          </ListTag>
        );
      case 'image':
        return (
          <figure key={index} className="article-image">
            <img 
              src={block.src} 
              alt={block.alt || ''} 
              loading="lazy"
            />
            {block.caption && <figcaption>{block.caption}</figcaption>}
          </figure>
        );
      case 'footer':
        return <footer key={index} className={`callout callout--${block.variant || 'info'}`}>
          {block.title && <h3>{block.title}</h3>}
          <p>{block.content}</p>
        </footer>;
      default: 
        return (
        <div key={index} className="unknown-content">{block.content}</div>
        )
    }
  }
  return (
    <article>
      {Array.isArray(blocks) ? blocks.map((block, index) => renderContent(block, index)) :
        <div className="error">Invalid content format</div>
      }
    </article>
  );
};
export default ArticleRenderer;
